import BaseMutations from '@/store/base/mutations'

// const module = 'fuelCards'

export default BaseMutations({
	//
})
